import { FormControl } from '@angular/forms';

export interface AddAdminFormGroup {
  email: FormControl<string | undefined>;
  name: FormControl<string | undefined>;
  password: FormControl<string | undefined>;
  createdAt: FormControl<string | undefined>;
  permissions: FormControl<AdminPermissionVM[] | undefined>;
}

export enum AdminPermissionVM {
  AdminManagement = 'AdminManagement',
  BlackListManagement = 'BlackListManagement',
  ClaimManagement = 'ClaimManagement',
  RentalManagement = 'RentalManagement',
  CarManagement = 'CarManagement',
  CopyManagement = 'CopyManagement',
  StationManagement = 'StationManagement',
}

export enum AdminDialogType {
  Add = 'Add',
  Edit = 'Edit',
}
